import { BaseBenefitPlanPolicyPeriod } from "@platform/openapi-types";
import { formatPolicyPeriodDisplay } from "@platform/plan-grid-core";

interface PolicyPeriodOption {
  label: string;
  value: BaseBenefitPlanPolicyPeriod;
  /** Shown but not selectable (e.g. New Business once one already exists). */
  disabled?: boolean;
}

const buildPolicyPeriodOptions = (
  currentPolicyPeriod?: BaseBenefitPlanPolicyPeriod,
): PolicyPeriodOption[] => {
  const options: Omit<PolicyPeriodOption, "label">[] = [
    { value: BaseBenefitPlanPolicyPeriod.alternate },
  ];

  if (currentPolicyPeriod === BaseBenefitPlanPolicyPeriod.newBusiness) {
    // A coverage may have only one New Business plan group (XTRM-2023). When one
    // already exists, additional groups must be Alternate — show New Business
    // disabled rather than selectable so a second can't be added.
    options.push({
      value: BaseBenefitPlanPolicyPeriod.newBusiness,
      disabled: true,
    });
  } else if (currentPolicyPeriod === BaseBenefitPlanPolicyPeriod.current) {
    options.unshift({ value: BaseBenefitPlanPolicyPeriod.current });
  }

  return options.map((option) => ({
    ...option,
    label: formatPolicyPeriodDisplay(option.value),
  }));
};

export { buildPolicyPeriodOptions };
export type { PolicyPeriodOption };
